<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>
      {{ communication.title }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <b *ngIf='communication.status == 1' class="ion-padding">
    Delivered
  </b>

  <b *ngIf='communication.status == 0' class='sm-error' class="ion-padding">
    Delivery Failed
  </b>

  <ion-button fill="clear" (click)='resend()'>
    <ion-icon name='mail' *ngIf="communication.communicationType == 'client_email' || communication.communicationType == 'bulk_email'"></ion-icon>
    <ion-icon name='text' *ngIf="communication.communicationType == 'sms'"></ion-icon>
    Resend
  </ion-button>
  <ion-item lines="none" class="ion-text-wrap">
      <div [innerHTML]="decodedContent" class="message-container"></div>
    <!-- <br/> -->
    <!-- {{ communication.datetime | salonMonsterDate: 'dddd, MMMM D, Y h:mm a' }}   -->
  </ion-item>
</ion-content>